<template>
  <div class="x-post-preview">
    <div v-if="!currentPostId" class="x-post-preview__placeholder">
      <slot>{{ placeholderText }}</slot>
    </div>

    <template v-else>
      <TwitterPostEmbed :id="currentPostId" />
    </template>

    <el-pagination
      v-if="totalPages >= 2"
      class="x-post-preview__pagination"
      :page-size="1"
      :current-page="clampedPage"
      :total="totalPages"
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import TwitterPostEmbed from '@/client/components/_atoms/twitter_post_embed'

import { clampPage, selectPostId, PLACEHOLDER_TEXT } from './x_post_preview.utils'

export default defineComponent({
  name: 'XPostPreview',
  components: {
    TwitterPostEmbed
  },
  props: {
    postIds: {
      type: Array as PropType<(string | null)[]>,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: 1
    },
    placeholderText: {
      type: String,
      default: PLACEHOLDER_TEXT
    }
  },
  setup(props, context) {
    const clampedPage = computed(() => clampPage(props.currentPage, props.totalPages))

    const currentPostId = computed(() => selectPostId(props.postIds, props.currentPage))

    function handleCurrentChange(page: number) {
      context.emit('change', page)
    }

    return {
      clampedPage,
      currentPostId,
      handleCurrentChange
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.x-post-preview {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit;
  align-items: stretch;
  width: 100%;
  max-width: 550px;
}

.x-post-preview__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: $spacing-unit * 4;
  color: $sub-text-color;
  text-align: center;
  background: $background-color;
  border-radius: $round;
}

.x-post-preview__pagination {
  display: flex;
  align-items: center;
  align-self: center;
}
</style>
